import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    error: null,
    teams: [],
};

export const analyticTeamSlice = createSlice({
    name: 'analyticTeam',
    initialState,
    reducers: {
        setAnalyticTeams: (state, action) => {
            state.loading = false;
            state.error = null;
            state.teams = action.payload || [];
        },
        updateAnalyticTeam: (state, action) => {
            state.loading = false;
            state.error = null;
            const t = action.payload;
            state.teams = state.teams.map(x => (x.teamId === t.teamId ? { ...x, ...t } : x));
        },
        deleteAnalyticTeam: (state, action) => {
            state.loading = false;
            state.error = null;
            state.teams = state.teams.filter(x => x.teamId !== action.payload);
        },
        resetAnalyticTeam: () => initialState,
    },
});

export const {
  setAnalyticTeams,
  updateAnalyticTeam,
  deleteAnalyticTeam,
  resetAnalyticTeam,
} = analyticTeamSlice.actions;


// Selectors
export const selectAnalyticTeam = (state) => state.analyticTeam;
export const selectAnalyticTeamById = (teamId) => (state) =>
  state.analyticTeam.teams.find(t => t.teamId === teamId);

export default analyticTeamSlice.reducer;
